import React from 'react'
import { Field, Form, Formik } from 'formik'
import _isEmpty from 'lodash/isEmpty'

import Button from '../Button'
import { CustomToggleField, SelectField, SimpleField } from '../../formik/Fields'
import { requiredValidator } from '../../../_common/core/validation'
import CustomFieldOptions from './CustomFieldOptions'
import { validateForm } from './utils/formValidation'
import { FIELDS, fieldTypeOptions, toggles } from './utils/constants'

const CustomFieldForm = props => {
  const { fieldData, customFieldsData, onSubmit, onClose } = props
  const isEditing = !_isEmpty(fieldData)

  return (
    <Formik
      initialValues={{
        parentType: 'order',
        type: 'text',
        label: '',
        name: '',
        defaultValue: '',
        required: false,
        settings: {
          showOnMyTickets: false,
          showOnPdf: false,
          showOnScan: false,
          allowUpdate: false,
        },
        selectOptions: [],
        multiSelectOptions: [],
        radioOptions: [],
        ...fieldData,
      }}
      onSubmit={values => {
        onSubmit(values)
      }}
      validateOnMount={false}
      validate={valuesData => validateForm(valuesData, customFieldsData)}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <Form>
          <div className="row" style={{}}>
            <div className="col-xs-12">
              <Field
                name="parentType"
                label="Append to"
                component={SelectField}
                options={[
                  {
                    value: 'order',
                    label: 'Order',
                  },
                  {
                    value: 'ticket',
                    label: 'Ticket',
                  },
                  {
                    value: 'add-on',
                    label: 'Add-On',
                  },
                ]}
                validate={requiredValidator()}
                disabled={isEditing}
              />
            </div>
          </div>
          <div className="row" style={{}}>
            <div className="col-xs-12 col-sm-6">
              <Field
                name="type"
                label="Type"
                component={SelectField}
                options={fieldTypeOptions}
                validate={requiredValidator()}
              />
            </div>
            <div className="col-xs-12 col-sm-6">
              <Field name="label" label="Label" component={SimpleField} validate={requiredValidator()} />
            </div>
            {values.type === FIELDS.SELECT.key && (
              <CustomFieldOptions
                values={values}
                errors={errors}
                fieldName={FIELDS.SELECT.optionsKey}
                addBtnLabel="Add Select Option"
                setFieldValue={setFieldValue}
              />
            )}
            {values.type === FIELDS.SELECT_MULTI.key && (
              <CustomFieldOptions
                values={values}
                errors={errors}
                fieldName={FIELDS.SELECT_MULTI.optionsKey}
                addBtnLabel="Add Multi Select Option"
              />
            )}
            {values.type === FIELDS.RADIO.key && (
              <CustomFieldOptions
                values={values}
                errors={errors}
                fieldName={FIELDS.RADIO.optionsKey}
                addBtnLabel="Add Radio Option"
              />
            )}
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <Field
                name="name"
                label="Name"
                component={SimpleField}
                validate={requiredValidator()}
                helperText={`
                  The Name field should not contain numbers or spaces.
                  You can replace spaces with underscore like 'first_name' or 'last_name'.
                `}
              />
            </div>
            <div className="col-xs-12 col-sm-6">
              <Field name="defaultValue" label="Default Value" component={SimpleField} />
            </div>
          </div>
          <div className="row">
            {toggles.map(toggleItem => (
              <div key={toggleItem.key} className="col-xs-12 col-sm-6">
                <Field name={toggleItem.key} onText={toggleItem.onText} component={CustomToggleField} />
              </div>
            ))}
          </div>
          <div className="modal-footer" style={{ margin: '20px -15px 0px' }}>
            <div className="btn-toolbar btn-toolbar-right">
              <Button
                className="btn btn-default btn-success"
                type="button"
                onClick={() => {
                  handleSubmit()
                }}
              >
                {isEditing ? 'Update' : 'Create'}
              </Button>
              <Button className="btn btn-default btn-cancel" type="button" onClick={onClose}>
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default CustomFieldForm
